const nonNegativeInteger = (value) => Math.max(0, Math.floor(Number(value) || 0));

/** Apply declared damage operations in order while retaining both arithmetic bases. */
export const applyIncomingDamageModifiers = ({ rawDamage, calculatedDamage }, modifiers = []) => {
  const raw = nonNegativeInteger(rawDamage);
  let current = nonNegativeInteger(calculatedDamage);
  const records = modifiers.map((modifier) => {
    const before = current;
    const basisValue = modifier?.basis === 'raw-damage' ? raw : current;
    switch (modifier?.operation) {
      case 'subtract-flat': current = Math.max(0,basisValue - nonNegativeInteger(modifier.amount)); break;
      case 'halve-floor': current = Math.floor(basisValue / 2); break;
      case 'replace-with-zero': current = 0; break;
      default: break;
    }
    return Object.freeze({ ...modifier, before, after: current, reduction: before - current });
  });
  return Object.freeze({ rawDamage: raw, calculatedDamage: nonNegativeInteger(calculatedDamage), modifiers: records, finalDamage: current });
};
